import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
    // paddingVertical: 20,
  },
  labelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    marginBottom: 12,
  },
  sectionTitle: {
    fontWeight: '700',
    color: '#1C1C1E',
  },
  requiredAsterisk: {
    color: '#B04B3A',
    fontSize: 16,
  },
  inputWrapper: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    backgroundColor: '#FFF',
    minHeight: 44,
    justifyContent: 'center',
  },
  inputSlot: {
    width: '100%',
    minWidth: 0,
    justifyContent: 'center',
  },
  input: {
    width: '100%',
    minHeight: 44,
    paddingHorizontal: 12,
    paddingTop: 0,
    paddingBottom: 2,
    fontSize: 13,
    lineHeight: 15,
    color: '#1E1E1E',
    backgroundColor: 'transparent',
    borderWidth: 0,
    textAlignVertical: 'center',
    includeFontPadding: false,
  },

  inputError: {
    borderColor: '#900B09',
  },
  errorText: {
    fontSize: 12,
    color: '#900B09',
    fontWeight: '400',
    marginTop: 4,
  },

  shareLinkBox: {
    marginTop: 12,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    padding: 16,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  shareLinkLabel: {
    color: '#383838',
    fontSize: 12,
    fontWeight: '500',
    letterSpacing: 0.5,
    marginBottom: 8,
  },
  urlRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  urlContainer: {
    flex: 1,
    minWidth: 0,
  },
  urlText: {
    flex: 1,
    minWidth: 0,
    // color: '#2563EB',
    color: '#3B82F6',
    fontSize: 14,
    fontWeight: '500',
    marginRight: 12,
  },
  copyBtn: {
    padding: 4,
    flexShrink: 0,
  },
  copyIcon: {
    fontSize: 20,
    color: '#1E1E1E',
  },
});
